import { configureStore } from "@reduxjs/toolkit";
import postReducer from "./postSlice";
import adminReducer from "./adminSlice";
import questionReducer from "./questionSlice";

export const store = configureStore({
  reducer: {
    post: postReducer,
    admin: adminReducer,
    question: questionReducer,
  },
});
